// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__YjA+m","check-box":"checkbox_check-box__udFDa","checkmark":"checkbox_checkmark__oBidd"};